module.exports = __webpack_public_path__ + "static/media/smelter2.54e81d81.jpg";